var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:{
        'alert-info': !_vm.confirmed && !_vm.confirmed,
        'alert-success': _vm.confirmed,
        'alert-danger': _vm.cancelled,
    },attrs:{"role":"alert"}},[(_vm.confirmed)?_c('div',[_c('i',{staticClass:"fas fa-check mr-1"}),_vm._v(" Seu pagamento foi confirmado! ")]):(_vm.cancelled)?_c('div',[_c('i',{staticClass:"fas fa-times mr-1"}),_vm._v(" Seu pagamento não foi aprovado. Em caso de dúvida, entre em contato com o suporte. ")]):_c('div',[_c('i',{staticClass:"fas fa-circle-notch fa-spin mr-1"}),_vm._v(" Verificando o seu pagamento... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }